import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HeaderHelperService } from '../header-helper.service';
import { FilterModel } from '../../models/filters/filters.model';
import { SortModel } from '../../models/filters/sort.model';

export interface AdminReportFilterModel {
  userBranches?: [];
  year?: number | null;
  month?: number | null;
}
@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  getAnalysisReportCountByCustomer(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/OrganizationAdminReport/GetAnalysisReportCountByCustomer?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters) {
      const resultFilter = filters.filter((x) => !!x.value);
      url += resultFilter.map((f) => `&${f.filterId}=${f.value}`).join('');
    }
    if (sort) {
      url += `&SortBy=${sort.column}&SortDescending=${
        sort.orderBy == 'descending'
      }`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getAnalysisReportCountByCustomerBranch(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Observable<any> {
    const url = `${environment.apiLocations.patient}/OrganizationAdminReport/GetAnalysisReportCountByCustomerBranch`;

    const requestBody = {
      pageRequest: {
        pageIndex: page - 1,
        pageSize: size,
      },
      userBranches:
        filters?.find((x) => x.filterId === 'CustomerCode')?.value || [],
      year: filters?.find((x) => x.filterId === 'Year')?.value || null,
      month: filters?.find((x) => x.filterId === 'Month')?.value || null,
    };

    return this.http.post<any>(url, requestBody, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  getAnalysisReportCountByCurrentDermatologist(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/DermatologistReport/GetAnalysisReportCountByCurrentDermatologist?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters) {
      const resultFilter = filters.filter((x) => !!x.value);
      url += resultFilter.map((f) => `&${f.filterId}=${f.value}`).join('');
    }
    if (sort) {
      url += `&SortBy=${sort.column}&SortDescending=${
        sort.orderBy == 'descending'
      }`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
